import { useHistory } from "react-router-dom";
import {
	Card,
	CardContent,
	Button,
	Typography,
	makeStyles,
} from "@material-ui/core";

function NotAllowed() {
	const history = useHistory();

	const useStyles = makeStyles((theme) => ({
		notAllowed: {
			margin: "1rem",
		},
	}));

	const classes = useStyles();

	return (
		<Card className={classes.notAllowed}>
			<CardContent>
				<Typography gutterBottom variant="h5" component="h2">
					Not allowed to view preview
				</Typography>
				<Typography>Please log in to preview this page.</Typography>
				<Button
					variant="contained"
					color="primary"
					style={{ marginTop: "1rem" }}
					onClick={() => {
						history.goBack();
					}}
				>
					Go Back
				</Button>
			</CardContent>
		</Card>
	);
}

export default NotAllowed;
